<template>
  <div class="smart-wrap" style="display: flex; align-items: center;  flex-wrap: nowrap; justify-content: center;  padding: 20px;">
    <router-link class="btn-g show blue" :to="{ path:'/smartmaker',query: { name:'SMLUP', PK:publicOrganization, SK:url.sml, } }" style="margin: 0 10px;" >
      Design
    </router-link>
    <router-link class="btn-g show gray" :to="{ path:'/makerpreview',query: {PK:publicOrganization, SK:url.sml,  } }"   style="margin: 0 10px;">
      Preview
    </router-link>
    <!--ui-button text="Publish" style="width: 300px; margin: 0 10px;" color="green" v-on:click="render = true;  getLayout()" /-->
  </div>
  <section v-if="layout && render != true">
    <!---->
      <!--div v-if="SML.templateType == 'hf'" id="container-web" :style="'width:'+ displayWebSite[widthDisplayWebSite]+';'">
        <paper-web-edit v-if="renderWeb " :id="widthDisplayWebSite" :style="setSetyleBoddy(bodyStyle) " :idioms="SML.idioms" :language="language" :layout="layout" :binds="data" :palette="palette" :paperPermissions="{usersCanEdit:[], usersCanRead:[],groupsCanEdit:[],groupsCanRead:[]}"/>
      </!--div-->
      <div id="container-web" :style="'width:'+ displayWebSite[widthDisplayWebSite]+';'">
        <paper-web-edit  v-if="renderWeb " :style="setSetyleBoddy(bodyStyle)" :webIdioms="SML.idioms" :webLayout="layout" :webBinds="data" :webPalette="palette" />
      </div>
    <!---->
  </section>
  
  <section v-if="render == true">
    <!--div v-if="SML.templateType == 'hf'" id="container-web" :style="'width:'+ displayWebSite[widthDisplayWebSite]+';'">
      <paper-layout v-if="renderWeb " :id="widthDisplayWebSite" :style="setSetyleBoddy(bodyStyle) " :idioms="SML.idioms" :language="language" :layout="layout" :models="data" :palette="palette" :paperPermissions="{usersCanEdit:[], usersCanRead:[],groupsCanEdit:[],groupsCanRead:[]}"/>
    </!--div-->
    <div id="container-web" :style="'width:'+ displayWebSite[widthDisplayWebSite]+';'">
      <paper-layout  v-if="renderWeb && layout "  :idioms="SML.idioms" :language="language" :layout="layout" :models="data" :palette="palette" :paperPermissions="{usersCanEdit:[], usersCanRead:[],groupsCanEdit:[],groupsCanRead:[]}"/>
    </div>

  </section>
  <section class="maker footer">
    <ui-modal name="custom" type="custom"  >
      <template v-if="customWeb != null"  #content>
        <div class="panel smart-wrap">
          <div class="element-wrap col-md-12" style="margin:0;">
            <h4>{{customWeb[0].attributeName}}</h4>
            <p>{{customWeb[0].id}}</p>
          </div>
          <div v-if="customWeb[0].elementType.toLowerCase() == 'img'" class="input-wrap col-md-12" style="margin:0;">
            <img style="width: 100%; margin: 20px 0;" :src="JSON.parse(customWeb[1][customWeb[0].attributeName].attributeValue)[0].url" alt="">
            <label for="">Img</label>
            <textarea name="" id="" cols="30" rows="5" v-model="descriptionFile"></textarea>
            <input type="file"  v-on:change="fileUp" name="" id="">
          </div>
          <div v-else class="input-wrap col-md-12" style="margin:0;">
            <label for="">Text</label>
            <textarea name="" id="" cols="30" rows="10" v-model="customWeb[1][customWeb[0].attributeName].attributeValue "></textarea>
          </div>
        </div>
        <div class="action">
          <ui-button text="Apply"  style="width: calc(80% - 10px); float:left; margin:0 5px;" color="green" v-on:click="attUpdate(customWeb)" data-dismiss="modal"/>
          <ui-button text="X" style="width: calc(20% - 10px); float:left; margin:0 5px;" data-dismiss="modal" />
        </div>
      </template>
    </ui-modal>   
    <paper-modal/>
  </section>
  
</template>
<script>
//AWS
import { smd_getRecord, smd_getDashData, smd_listEntity, smd_getWebPage, smd_generateWebSite  } from '../graphql/queries'
import { smd_updateAttributes } from '../graphql/mutations'
import { loading, popUp } from '../store/tools.js'

//Tools
import Vuex from 'vuex'
import { API, Storage, Auth } from 'aws-amplify'
import { v4 as uuidv4 } from 'uuid';  
//Components
import PaperWebEdit from '../components/papers/PaperWebEdit.vue'
import PaperLayout from '../components/papers/PaperLayout.vue'
import PaperModal from '../components/papers/PaperModal.vue'
import PaperDisplayer from '../components/papers/PaperDisplayer.vue'
import UiButton from '../components/ui/UiButton.vue'
import UiModal from '../components/ui/UiModal.vue'
export default {
  name: 'web-site',
  components:{
    PaperWebEdit,
    PaperLayout,
    PaperModal,
    PaperDisplayer,
    UiModal,
    UiButton
  },
  data() {
    return {
      
      test:{ "entity": { "SK": "#ENT#d34573f8-d708-48e1-9734-e79fb502bce0", "PK": "#SMARTDASH" }, "version": "1.1", "createdAt": "2023-02-27T19:21:17", "updatedBy": "smdadmin", "createdBy": "adminwilson@smartdash-ez.com", "groupsCanRead": [ "Admin", "Editor", "Superadmin" ], "active": "1", "entityName": "PRODUCT", "usersCanEdit": [ "@author" ], "shortEntity": "PRO", "updatedAt": "2023-03-03T21:50:43", "GSP1SK1": "PRO#14d0a329-edc4-4bf9-87cf-012ac8f2468f", "GSP5SK1": "2023-02-27T19:21:17", "usersCanRead": [ "@author" ], "SK": "PRO#14d0a329-edc4-4bf9-87cf-012ac8f2468f", "GSP5PK1": "ORG#WILSONC#PRO", "form": { "SK": "#SML#4b4f7cdb-7a03-4877-a87b-d935c481f7c3", "PK": "#SMARTDASH" }, "PK": "ORG#WILSONC", "friendlyId": 3, "groupsCanEdit": [ "Admin", "Editor", "Superadmin" ], "category": { "attributeName": "category", "label": "Category", "attributeValue": "{\"PK\":\"ORG#WILSONC\",\"SK\":\"PCT#5b5a08be-4222-4a08-a2bd-3a10b169d481\",\"value\":\"Services\"}", "attributeType": "L" }, "product.name": { "attributeName": "product.name", "label": "Product Name", "attributeValue": "Framing 1", "attributeType": "S" }, "shortDescription": { "attributeName": "shortDescription", "label": "Short Description", "attributeValue": "", "attributeType": "S" }, "product.description": { "attributeName": "product.description", "label": "Product Description", "attributeValue": "", "attributeType": "S" }, "description": { "attributeName": "description", "label": "Description (HTML)", "attributeValue": "", "attributeType": "HTML" }, "featureinWeb": { "attributeName": "featureinWeb", "label": "Show In website", "attributeValue": "", "attributeType": "B" }, "order": { "attributeName": "order", "label": "Order", "attributeValue": "", "attributeType": "S" }, "product.price": { "attributeName": "product.price", "label": "Price", "attributeValue": "", "attributeType": "S" }, "template": { "attributeName": "template", "label": "Template( HTML)", "attributeValue": "", "attributeType": "S" }, "path": { "attributeName": "path", "label": "Path", "attributeValue": "", "attributeType": "S" }, "templateType": { "attributeName": "templateType", "label": "Template Type", "attributeValue": "", "attributeType": "S" }, "metaTitle": { "attributeName": "metaTitle", "label": "Meta Title", "attributeValue": "", "attributeType": "S" }, "metaShortDescription": { "attributeName": "metaShortDescription", "label": "Meta Short Description", "attributeValue": "", "attributeType": "S" }, "SEOKeyWords": { "attributeName": "SEOKeyWords", "label": "SEO Keywords", "attributeValue": "", "attributeType": "S" }, "metaImage": { "attributeName": "metaImage", "label": "Meta Image URL", "attributeValue": "", "attributeType": "S" }, "featureImage": { "attributeName": "featureImage", "label": "Feature Image ", "attributeValue": "[{\"name\":\"Screenshot 2023-02-27 at 3.12.52 PM.png\",\"url\":\"https://smartdashs3120108-dev.s3.amazonaws.com/public/ORG%23WILSONC/89364395-cb9f-4f4b-b85e-975caed2f922.png\",\"key\":\"89364395-cb9f-4f4b-b85e-975caed2f922.png\",\"security\":\"public\",\"description\":\"\",\"identityId\":\"us-east-1:b110c867-4f83-4fc6-870b-0534d189a427\",\"route\":\"public/us-east-1:b110c867-4f83-4fc6-870b-0534d189a427/ORG#WILSONC/89364395-cb9f-4f4b-b85e-975caed2f922.png\",\"createdAt\":\"2023-02-27T20:14:22.005Z\"}]", "attributeType": "L" }, "productImages": { "attributeName": "productImages", "label": "Gallery", "attributeValue": "[]", "attributeType": "L" }, "iconsColor": { "attributeName": "iconsColor", "label": "Icons (Color)", "attributeValue": "[]", "attributeType": "L" }, "iconsBlack": { "attributeName": "iconsBlack", "label": "Icons (Black)", "attributeValue": "[]", "attributeType": "L" }, "variants": { "attributeName": "variants", "label": "Variants", "attributeValue": "[]", "attributeType": "L" }, "variantName": { "attributeName": "variantName", "label": "Name", "attributeValue": "", "attributeType": "S" }, "variantDescription": { "attributeName": "variantDescription", "label": "Description", "attributeValue": "", "attributeType": "S" }, "variantImage": { "attributeName": "variantImage", "label": "image", "attributeValue": "[]", "attributeType": "L" }, "variantPrice": { "attributeName": "variantPrice", "label": "Price", "attributeValue": "", "attributeType": "S" }, "smartFormProgress": { "attributeName": "smartFormProgress", "inputType": "range", "label": "Smart Form Progress", "attributeValue": "NaN", "attributeType": "N" } },
      
      webs:[
        {domain:'dafsd' }
      ],
      render: false,
      layout:undefined,
      data:'',
      organization: null,
      SML:{},
      language: null,
      palette:[],
      bodyStyle: '',
      url:{},
      HTMLWebSite:{},
      renderWeb:true,
      widthDisplayWebSite:'desk',
      displayWebSite: {
        desk:'100%',
        laptop:'992px',
        tablet:'767px',
        phone:'450px',
      },
      descriptionFile:'descriptionFile',
    }
  },
  created() {
    console.clear()
    
    this.url = this.$router.currentRoute.value.query
    this.setUserWeb()
  },
  mounted() {
    //console.clear();

  },
  methods: {
    ...Vuex.mapMutations(['setPublicOrganization','SetOrganizationData',"setWebSite",'SetUser','SetPageQuery','setgRecord']),
    ...Vuex.mapActions(['getPublicOrganization']),
    async setUserWeb(){
      this.getLayout()
      /*Auth.signIn('smd_webuser', '383@JDU45ss#')
      .then((user) => { 
        this.SetUser(user.username)
      })
      .catch((err) => console.log(err));*/
    },
    async getLayout(){
      //console.clear()
      this.layout = undefined
      loading('show','webPreview')
      await this.getPublicOrganization();
      let config = {};
      let pullData = ''
      try {
        config ={
          orgPK: this.publicOrganization,
          SMLPK: this.publicOrganization,
          SMLSK: this.url.sml
        }
        console.log('Config Get Layout:', config);
        pullData = await API.graphql({
          query: smd_getWebPage,
          variables: config
        });
        this.SML = {}
        pullData = pullData.data.smd_getWebPage
        pullData = JSON.parse(pullData.data)
        //console.clear()
        console.log('--> getLayoutData: ', pullData);
        for (let index = 0; index < JSON.parse(pullData.SML).length; index++) {
          const element = JSON.parse(pullData.SML)[index];
          if (element.attributeType == 'L') {
            element.attributeValue =JSON.parse(element.attributeValue)
          }
          this.SML[element.attributeName] =element.attributeValue
        }
        this.language = this.SML.idioms[0]
        console.log('--> SML: ', this.SML);
        this.data = pullData.binds
        //Process binds To Add Record ----
        if (this.render ==  false) {
          for (const key in this.data) {
            if (typeof this.data[key] == 'object') {
              if (this.data[key][0] && this.data[key][0].ADD) {
                let shortEntity = this.data[key][0]['ADD'].dataSet.query.sortKeyBeginsWith
                console.log(this.entities[shortEntity]);
                this.data[key][0] = {
                  SK : 'ADD',
                  PK: this.publicOrganization,
                  form: { PK: JSON.parse(this.entities[shortEntity]['metaEntity.defaultFormLayout']).PK, SK: JSON.parse(this.entities[shortEntity]['metaEntity.defaultFormLayout']).SK},
                  shortEntity: shortEntity,
                  entity: { PK: this.entities[shortEntity].PK, SK:this.entities[shortEntity].SK},
                  group : { attributeValue: this.data[key][0]['ADD'].dataSet.query.group}
                }
                console.log(this.data[key][0]);
              }else{
                this.data[key].push({
                  ...this.data[key][0],
                  SK:'ADD'
                })
              }
              this.SetPageQuery(this.data[key][0].shortEntity);
            }
          }
          console.log('binds',this.data);
        // -------------------------------
        }
        this.palette = this.SML.palette
        this.bodyStyle = this.SML.bodyStyle
        this.setWebSite(this.SML)
        document.head.insertAdjacentHTML("beforeend", this.SML.fontScript)
        this.layout = pullData.layout
        if (this.render ==  true) {
          setTimeout(() => {
            console.log('aqui llamo a renderizar');
            this.renderWebContainer();
          }, 1000);
        }
      } catch (error) {
        console.log(error);
      }
      loading('hidde', 'getItem')
      console.timeEnd()
    },
    async getLayoutBinds( layout ){
      console.log('--> getLayoutBinds:',layout.PK +" - "+ layout.SK +" - "+ this.organization);
      try {
        let wo_PullItem = ''
        wo_PullItem = await API.graphql({
          query: smd_getDashData,
          variables: {
            SMLPK: layout.PK,
            SMLSK: layout.SK,
            ORGPK: layout.PK//this.publicOrganization''
          },
        });
        console.log(wo_PullItem);
        wo_PullItem = wo_PullItem.data.smd_getDashData
        console.log('--> getLayoutBinds: ',wo_PullItem);
        this.data = JSON.parse(wo_PullItem.data)
      } catch (error) {
        console.log(error);
      }
    },
    async getClass(){
      try {
        console.log('smd_listEntity: ');
        let classes = [];
        let cssCode = '';
        let pullData = await API.graphql({
          query: smd_listEntity,
          variables: {
            PK: this.organization,
            active: '1',
            shortEntity: 'CSS',
          },
        });
        pullData = pullData.data.smd_listEntity.data
        console.log(pullData);
        for (let index = 0; index < pullData.length; index++) {
          let tmpClass = {}
          pullData[index].attributes.forEach(element => {
            switch (element.attributeName) {
              case 'name':
                tmpClass.name =element.attributeValue
              break;
              case 'elementType':
                tmpClass.component =element.attributeValue
              break;
              case 'code':
                tmpClass.code = unescape(element.attributeValue)
              break;
            }
          });
          classes.push(tmpClass)
        }
        
        classes.forEach(element => {
          cssCode = cssCode +' '+element.code
        });
        //console.log(classes);
        //console.log(cssCode);
        //Set stley in head <style>
        document.head.insertAdjacentHTML("beforeend", `<style>${cssCode}</style>`)        
      } catch (error) {
        console.log(error);
      }

    },
    setSetyleBoddy(data){
      let palette = this.palette
      let style = data
      let regexp = /\[.+?\]/g;
      let bind = [...style.matchAll(regexp)];

      for (let index = 0; index < bind.length; index++) {
        let parameter = JSON.parse(bind[index][0])
        style = style.replace(bind[index][0], palette[parameter[1]])
      }
      return style
    },
    //Edit
    async attUpdate(data){
      loading('show', 'getItem')
      console.log(data);
      let pushData = ''
      let att = []
      att =[
        { 
          attributeName: data[0].attributeName,
          attributeType: "L",
          attributeValue: data[1][data[0].attributeName].attributeValue
        },
      ]
      if (data[0].elementType = 'Img') {
        att[0].attributeType = 'L'
      }else{
        att[0].attributeType = 'S'
      }
      console.log(att);
      try {
        pushData = await API.graphql({
            query: smd_updateAttributes, //smd_updateSmartRecord
            variables: { 
              PK: data[1].PK,
              SK: data[1].SK ,
              attributes: JSON.stringify(att) ,
            },
        });
        this.getLayout()
        //this.generateWebSite()
      } catch (error) {
        popUp(error, 'cach', 'err')
      }
      loading('hidde', 'getItem')
    },
    //file Down and Up  
    async fileUp(e){
      console.clear()
      loading('show');
      //File Config
      let event = e
      try {
        let name = event.target.value.replace('C:\\fakepath\\', '')
        let extension = name.split('.')[name.split('.').length-1]
        let data = {
          name: name,
          extension: extension,
          key: uuidv4()+"."+extension,
          securityFile: 'public',
          file: event.target.files[0],
          component: '',
          index: event.target.id
        }
        
        if (data.file) {
          let result = await Storage.put(
            this.publicOrganization+"/"+data.key,
            data.file,
            {
              contentDisposition: "inline",
              contentType: data.file.type,
              level: data.securityFile,
            }
          );
        }
        let att =[{
          name: data.name,
          url: 'https://smartdashs3120108-dev.s3.amazonaws.com/public/'+ this.publicOrganization.replace('#','%23')+"/"+data.key,
          key: data.key, 
          security: data.securityFile, 
          description: this.descriptionFile,
          identityId:this.identityId,
          route: data.securityFile+'/'+this.identityId+'/'+this.publicOrganization+"/"+ data.key,
          createdAt: new Date().toISOString(),
        }]
        console.log(data);
        console.log(att);
        this.descriptionFile = ''
        this.customWeb[1][this.customWeb[0].attributeName].attributeValue = JSON.stringify(att)
      } catch (error) {
        console.log(error);
        popUp(error, 'cach', 'err')
      }
      loading('close');
    },

    //Generate Website F
    async generateWebSite(){
      //console.clear()
      let pushData = {};
      let pullData = ''
      try {
        pushData ={
          itemPK: this.publicOrganization,
          itemSK: this.url.sml,
          destination: this.SML.path,
          template: this.SML.template,
          HTML0: this.HTMLWebSite['desk'],
          HTML1: this.HTMLWebSite['laptop'],
          HTML2: this.HTMLWebSite['tablet'],
          HTML3: this.HTMLWebSite['phone']
        }
        console.log(pushData);
        pullData = await API.graphql({
          query: smd_generateWebSite,
          variables: pushData
        });
        pullData = pullData.data.smd_generateWebSite
        console.log(pullData);
      } catch (error) {
        console.log(error);
        popUp(error, 'cach', 'err')
      }
      this.renderWeb = true
      this.render = false
      this.widthDisplayWebSite = 'desk'
      this.getLayout()
      loading('hidde', 'getItem')
    },
    renderWebContainer(){
      loading('show','webPreview')
      var i = 0;  
      let view = ['desk','laptop','tablet', 'phone']
      var that = this;
      that.renderWeb = true     
      function myLoop() {    
        setTimeout(function() {  
          that.HTMLWebSite[that.widthDisplayWebSite] = document.getElementById('container-web').innerHTML             
          that.renderWeb = false
          console.log(view[i]+' - ' + i, document.getElementById('container-web') , that.renderWeb);
          that.viewResponsive++
          i++;                    
          if (i < 4) {           
            setTimeout(() => {
              that.renderWeb = true     
            }, 100);
            that.widthDisplayWebSite = view[i]   
            myLoop();             
          }    
        }, 4000)
        return true
      }

      myLoop();  
      setTimeout(() => {
        console.log(that.HTMLWebSite);
        //this.HTMLWebSite[this.widthDisplayWebSite] = document.getElementById('container-web').innerHTML    
        this.renderWeb = false
        //this.viewResponsive()
        this.generateWebSite()
      }, 20000);

    },
  },
  computed:{
    ...Vuex.mapState(['organization','user','publicOrganizationData','publicOrganization','customWeb','identityId','entities','gRecord'])
  },
  watch:{
    gRecord:{
      handler(val) {
        let data = {}
        let exist = undefined
        console.log('grecord:',this.data, val);
        if (val != null && val[2] == 'stay') {
          for (const key in val[0].attributes) {
            data[key] = val[0].attributes[key]
          }
          
          for (let index = 0; index < this.data[val[3]].length; index++) {
            let component = this.data[val[3]][index];

            if (component.SK == val[0].SK) {
              exist = index
              console.log('bingo',val[0]);
             // this.data[val[3]][index]= element
            }

          }
          const record = {...val[0], ...data}
          console.log(exist,record);
          if (exist  != undefined ) {
            console.log('edit');
            this.data[val[3]][exist] = {...record}
          }else{
            console.log('new');
            this.data[val[3]].splice(  this.data[val[3]].length-1  ,0,{...record})
          }
        }
      },
      deep: true
    },  
  }
}
</script>